import React, { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FIGURE, FIGURE_TYPE } from "../logic/chartConfig"
import { changeChartDefaultFigureOptions } from "redux/ducks/Chart"
import { Btn } from "components/atoms/btn"
import _ from "lodash"
import { Modal } from "react-bootstrap"

interface props {
  canvasId: string
  onHide?: Function
  show?: boolean
}

export const ChartFigureSettingModal = React.memo((props: props) => {
  const { canvasId, onHide, show } = props
  const dispatch = useDispatch()
  const defaultFigureOptionsSelector = (state: any) =>
    state.chart.defaultFigureOptions
  const figureSelector = (state: any) => state.chart[canvasId].figure
  const figureTypeSelector = (state: any) => state.chart[canvasId].figureType
  const figureOptionsSelector = (state: any) =>
    state.chart[canvasId].figureOptions

  const defaultFigureOptions = useSelector(defaultFigureOptionsSelector)
  const figure = useSelector(figureSelector)
  const figureType = useSelector(figureTypeSelector)
  const figureOptions = useSelector(figureOptionsSelector)
  const initialData = useMemo(() => {
    let _data: Array<Array<Array<number>>> = [[], [], []]
    _.forEach(defaultFigureOptions, items => {
      _data[items.figure].push(items.option)
    })
    return _data
  }, [])
  const [selectedItems, setSelectItems] = useState([[], [], []])
  const [selectedOptions, setSelectOptions] = useState(initialData)
  const _setSelectedItems = (targetId: number, parendGroupId: number) => {
    const _selectedItems = _.clone(selectedItems)
    if (_.includes(_selectedItems[parendGroupId], targetId)) {
      _.pull(_selectedItems[parendGroupId], targetId)
    } else {
      _selectedItems[parendGroupId].push(targetId)
    }
    setSelectItems(_selectedItems)
  }
  const _setSelectedOptions = (
    targetId: number,
    parendGroupId: number,
    typesId: number
  ) => {
    const _selectedOptions = _.clone(selectedOptions)
    if (_.includes(_selectedOptions[parendGroupId][typesId], targetId)) {
      _.pull(_selectedOptions[parendGroupId][typesId], targetId)
    } else {
      _selectedOptions[parendGroupId][typesId].push(targetId)
    }
    setSelectOptions(_selectedOptions)
  }

  useEffect(() => {
    let _defaultFigureOptions = defaultFigureOptions
    _.forEach(selectedOptions, (items, itemsId) => {
      _.forEach(items, (options, optionsId) => {
        _.set(
          _defaultFigureOptions,
          [FIGURE[itemsId].type[optionsId].key, "option"],
          options
        )
      })
    })
    dispatch(changeChartDefaultFigureOptions(_defaultFigureOptions))
  }, [selectedOptions])

  return (
    <Modal show={show} dialogClassName="chart-setting-modal">
      <Modal.Header>
        <div className="header-title">ライン設定</div>
        <div className="header-nav-icon-col">
          <div
            className="header-icon ripple"
            data-izimodal-close
            onClick={() => onHide()}
          >
            <i className="material-icons">close</i>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body-content">
          <div className="chart-setting-category">
            {_.map(FIGURE_TYPE, items => {
              return (
                <div key={items.key} className="chart-setting-item">
                  <div className="chart-setting-header">
                    <Btn
                      onClick={() => {
                        _setSelectedItems(items.id, items.parentId)
                      }}
                      name={items.displayTitle}
                    />
                    <i
                      className="material-icons"
                      onClick={() => {
                        _setSelectedItems(items.id, items.parentId)
                      }}
                    >
                      {_.includes(selectedItems[items.parentId], items.id)
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"}
                    </i>
                  </div>
                  {_.includes(selectedItems[items.parentId], items.id) && (
                    <div className="chart-setting-options">
                      {_.map(items.options, options => {
                        return (
                          <div
                            key={options.id}
                            className="chart-setting-options-item"
                          >
                            <label className="checkbox-control">
                              <input
                                type="checkbox"
                                value={options.id}
                                checked={_.includes(
                                  selectedOptions[items.parentId][items.id],
                                  options.id
                                )}
                                onChange={() => {
                                  _setSelectedOptions(
                                    options.id,
                                    items.parentId,
                                    items.id
                                  )
                                }}
                              />
                              <span>{options.displayTitle}</span>
                            </label>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-bottom-btn-row">
          <div
            className="btn btn-outline ripple"
            data-izimodal-close
            onClick={() => onHide()}
          >
            閉じる
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  )
})
